import React, { ReactElement, useEffect } from 'react';
import { Loader } from 'idsk-react-components';
import { useParams } from 'react-router';
import {
  Breadcrumbs, getTitle, homeBreadcrumb, setTitle,
} from 'slovlex-idsk-react-components';
import routes from '../../../routing/routes';
import useLegislativnyMaterialDetail
  from '../../../module/LegislativnyMaterial/LegislativnyMaterialDetail/hooks/useLegislativnyMaterialDetail';
import PageHeadingWithBackButton from '../../../module/PageHeadingWithBackButton';
import VyjadreniaPredbeznaInformacia from '../../../module/PracovnyKrok/VyjadreniaPredbeznaInformacia';
import GlobalErrors from '../../../module/GlobalErrors';
import Layout from '../../Layout';
import SecuredPage from '../../../module/SecuredPage';
import { StadiumMaterialuEnum } from '../../../model/legislativnyMaterial/StadiumMaterialu';
import { UserRoleEnum } from '../../../model/currentuser/UserRole';
import SuccessMessages from '../../../module/SuccessMessages';

const VyjadreniaConfigPage = (): ReactElement => {
  const {
    type,
    year,
    index,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number }>();
  const {
    materialDetail,
    materialStatus,
  } = useLegislativnyMaterialDetail();

  useEffect(() => {
    if (!materialStatus.loading) {
      setTitle(getTitle());
    }
  }, [materialStatus.loading]);

  return (
    <Layout>
      <Breadcrumbs routeList={[
        homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
        {
          to: routes.procesy.predbeznaInformacia.list,
          heading: 'Predbežné informácie',
        },
        {
          to: routes.procesy.detail.withParams(type, year, index),
          heading: `${type}/${year}/${index}`,
        },
        {
          to: routes.procesy.admin.vyjadrenia.config.withParams(type, year, index),
          heading: 'Zmena konfigurácie doby pre vyjadrovanie k materiálu',
        },
      ]}
      />
      <GlobalErrors />
      <Loader loading={materialStatus.loading}>
        <SecuredPage
          additionalCheck={materialDetail?.stadium?.hodnota === StadiumMaterialuEnum.VYJADRENIA}
          allowForRoles={[UserRoleEnum.SUPERADMIN]}
          requestStatus={materialStatus.responseCode}
        >
          <>
            <SuccessMessages />
            {materialDetail && (
              <>
                <PageHeadingWithBackButton
                  heading="Zmena konfigurácie doby pre vyjadrovanie k materiálu"
                  headingCaption={`Legislatívny proces ${materialDetail.cisloLegislativnehoMaterialu}`}
                />
                <VyjadreniaPredbeznaInformacia
                  materialDetail={materialDetail}
                  config
                />
              </>
            )}
          </>
        </SecuredPage>
      </Loader>
    </Layout>
  );
};

export default VyjadreniaConfigPage;
